import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetOffersResponse = App.Http.Responses.Offer.GetOffersResponse;
import GetOfferResponse = App.Http.Responses.Offer.GetOfferResponse;
import StoreOfferRequest = App.Http.Requests.Offer.StoreOfferRequest;
import UpdateOfferRequest = App.Http.Requests.Offer.UpdateOfferRequest;
import GetOffersRequest = App.Http.Requests.Offer.GetOffersRequest;
import GetOfferRequest = App.Http.Requests.Offer.GetOfferRequest;
import ExportResponse = App.Http.Responses.ExportResponse;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
class OfferApi extends TenantBaseApi {
    /**
     * Get list of offers
     *
     * - Request: GetOffersRequest
     * - Response: GetOffersResponse
     */
    async index(request: GetOffersRequest): Promise<GetOffersResponse> {
        return await this.get<GetOffersResponse, GetOffersRequest>("/offers", {
            params: request,
        });
    }

    /**
     * Store Offer
     *
     * - Request: StoreOfferRequest
     * - Response: GetOfferResponse
     */
    async store(request: StoreOfferRequest): Promise<GetOfferResponse> {
        return await this.post<GetOfferResponse, StoreOfferRequest>("/offers", request);
    }

    /**
     * Get specific offer
     *
     * - Request: { id: string }
     * - Response: GetOfferResponse
     */
    async show(offerId: string, request: GetOfferRequest): Promise<GetOfferResponse> {
        return await this.get<GetOfferResponse, GetOfferRequest>(`/offers/${offerId}`, {
            params: request,
        });
    }

    /**
     * Update Offer
     *
     * - Request: UpdateOfferRequest
     * - Response: GetOfferResponse
     */
    async update(request: UpdateOfferRequest, offerId: string): Promise<GetOfferResponse> {
        return await this.patch<GetOfferResponse, UpdateOfferRequest>(`/offers/${offerId}`, request);
    }

    /**
     * Delete Offer
     *
     * - Request: { id: string }
     * - Response: void
     */
    async destroy(offerId: string): Promise<void> {
        return await this.delete<void>(`/offers/${offerId}`);
    }

    async export(request: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>("/offers/export", request);
    }
}

export const offerApi = new OfferApi();
